// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/tag.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { FilterGroup, PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.Tag
 */
export const Tag = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Tag",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "namespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "created_at", kind: "message", T: Timestamp },
    { no: 14, name: "updated_at", kind: "message", T: Timestamp },
    { no: 15, name: "usage_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "group", kind: "message", T: TagGroup },
  ],
);

/**
 * @generated from message omnios.v1.TagGroup
 */
export const TagGroup = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TagGroup",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "exclusive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "required_for", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "tags", kind: "message", T: Tag, repeated: true },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Detailed info about a tag assignment on an entity
 *
 * @generated from message omnios.v1.EntityTagInfo
 */
export const EntityTagInfo = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EntityTagInfo",
  () => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag", kind: "message", T: Tag },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "applied_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "applied_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.TagRule
 */
export const TagRule = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TagRule",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "trigger_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "trigger_config", kind: "message", T: Struct },
    { no: 7, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "action_config", kind: "message", T: Struct },
    { no: 9, name: "entity_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.TagSuggestion
 */
export const TagSuggestion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TagSuggestion",
  () => [
    { no: 1, name: "tag", kind: "message", T: Tag },
    { no: 2, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateTagRequest
 */
export const CreateTagRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateTagRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "namespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateTagRequest
 */
export const UpdateTagRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateTagRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteTagRequest
 */
export const DeleteTagRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteTagRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetTagRequest
 */
export const GetTagRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTagRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTagsRequest
 */
export const ListTagsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTagsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "namespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "include_archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTagsResponse
 */
export const ListTagsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTagsResponse",
  () => [
    { no: 1, name: "tags", kind: "message", T: Tag, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.CreateTagGroupRequest
 */
export const CreateTagGroupRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateTagGroupRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "exclusive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "required_for", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateTagGroupRequest
 */
export const UpdateTagGroupRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateTagGroupRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "exclusive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "required_for", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteTagGroupRequest
 */
export const DeleteTagGroupRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteTagGroupRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTagGroupsRequest
 */
export const ListTagGroupsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTagGroupsRequest",
  () => [
    { no: 1, name: "include_tags", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTagGroupsResponse
 */
export const ListTagGroupsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTagGroupsResponse",
  () => [
    { no: 1, name: "groups", kind: "message", T: TagGroup, repeated: true },
  ],
);

/**
 * Add tags to entities (additive)
 *
 * @generated from message omnios.v1.ApplyTagsRequest
 */
export const ApplyTagsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApplyTagsRequest",
  () => [
    { no: 1, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entity_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ApplyTagsResponse
 */
export const ApplyTagsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApplyTagsResponse",
  () => [
    { no: 1, name: "applied_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Remove specific tags from entities
 *
 * @generated from message omnios.v1.RemoveTagsRequest
 */
export const RemoveTagsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemoveTagsRequest",
  () => [
    { no: 1, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entity_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RemoveTagsResponse
 */
export const RemoveTagsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemoveTagsResponse",
  () => [
    { no: 1, name: "removed_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Replace all tags on an entity with a new set
 *
 * @generated from message omnios.v1.ReplaceTagsRequest
 */
export const ReplaceTagsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReplaceTagsRequest",
  () => [
    { no: 1, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReplaceTagsResponse
 */
export const ReplaceTagsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReplaceTagsResponse",
  () => [
    { no: 1, name: "tags", kind: "message", T: EntityTagInfo, repeated: true },
  ],
);

/**
 * Get all tags on an entity with full info
 *
 * @generated from message omnios.v1.GetEntityTagsRequest
 */
export const GetEntityTagsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEntityTagsRequest",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEntityTagsResponse
 */
export const GetEntityTagsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEntityTagsResponse",
  () => [
    { no: 1, name: "tags", kind: "message", T: EntityTagInfo, repeated: true },
  ],
);

/**
 * Bulk: apply tags to entities matching a filter
 *
 * @generated from message omnios.v1.BulkTagEntitiesRequest
 */
export const BulkTagEntitiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkTagEntitiesRequest",
  () => [
    { no: 1, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "message", T: FilterGroup },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkTagEntitiesResponse
 */
export const BulkTagEntitiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkTagEntitiesResponse",
  () => [
    { no: 1, name: "matched_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "applied_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateTagRuleRequest
 */
export const CreateTagRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateTagRuleRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "trigger_config", kind: "message", T: Struct },
    { no: 5, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "action_config", kind: "message", T: Struct },
    { no: 7, name: "entity_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateTagRuleRequest
 */
export const UpdateTagRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateTagRuleRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "trigger_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "trigger_config", kind: "message", T: Struct },
    { no: 7, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "action_config", kind: "message", T: Struct },
    { no: 9, name: "entity_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteTagRuleRequest
 */
export const DeleteTagRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteTagRuleRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTagRulesRequest
 */
export const ListTagRulesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTagRulesRequest",
  () => [
    { no: 1, name: "trigger_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTagRulesResponse
 */
export const ListTagRulesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTagRulesResponse",
  () => [
    { no: 1, name: "rules", kind: "message", T: TagRule, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetTagSuggestionsRequest
 */
export const GetTagSuggestionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTagSuggestionsRequest",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetTagSuggestionsResponse
 */
export const GetTagSuggestionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTagSuggestionsResponse",
  () => [
    { no: 1, name: "suggestions", kind: "message", T: TagSuggestion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.TagEvent
 */
export const TagEvent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TagEvent",
  () => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(TagEvent_EventKind) },
    { no: 2, name: "tag", kind: "message", T: Tag },
    { no: 3, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "entity_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "actor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "timestamp", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from enum omnios.v1.TagEvent.EventKind
 */
export const TagEvent_EventKind = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.TagEvent.EventKind",
  [
    {no: 0, name: "EVENT_KIND_UNSPECIFIED"},
    {no: 1, name: "TAG_CREATED"},
    {no: 2, name: "TAG_UPDATED"},
    {no: 3, name: "TAG_DELETED"},
    {no: 4, name: "TAGS_APPLIED"},
    {no: 5, name: "TAGS_REMOVED"},
  ],
);

/**
 * @generated from message omnios.v1.StreamTagEventsRequest
 */
export const StreamTagEventsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StreamTagEventsRequest",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

